var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormatEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 0.938721H11.9C11.3754 0.938721 10.95 1.36409 10.95 1.88872C10.95 2.41335 11.3754 2.83872 11.9 2.83872H15.3066L10.5566 7.58872C10.1855 7.95959 10.1855 8.56122 10.5566 8.93208C10.7422 9.11763 10.9853 9.2104 11.2283 9.2104C11.4714 9.2104 11.7144 9.11763 11.9 8.93208L16.65 4.18208V7.58872C16.65 8.11335 17.0754 8.53872 17.6 8.53872C18.1246 8.53872 18.55 8.11335 18.55 7.58872V1.88872C18.55 1.36409 18.1246 0.938721 17.6 0.938721Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.950007 19.0608L6.65001 19.0608C7.17464 19.0608 7.60001 18.6354 7.60001 18.1108C7.60001 17.5862 7.17464 17.1608 6.65001 17.1608L3.24336 17.1608L7.90429 12.4999C8.27538 12.129 8.27538 11.5274 7.90429 11.1565C7.71874 10.971 7.47568 10.8782 7.23261 10.8782C6.98954 10.8782 6.74648 10.971 6.56093 11.1565L1.90001 15.8174L1.90001 12.4108C1.90001 11.8862 1.47464 11.4608 0.950008 11.4608C0.425374 11.4608 7.30295e-06 11.8862 7.25708e-06 12.4108L6.75877e-06 18.1108C6.71291e-06 18.6354 0.425374 19.0608 0.950007 19.0608Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9 12C18.3971 12 18.8 12.403 18.8 12.9L18.8 18.125C18.8 18.6221 18.3971 19.025 17.9 19.025H10.9C10.4029 19.025 10 18.6221 10 18.125C10 17.6279 10.4029 17.225 10.9 17.225H17L17 12.9C17 12.403 17.4029 12 17.9 12Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.899909 7.67505C0.402853 7.67505 -9.06343e-05 7.27211 -9.06777e-05 6.77505L-9.20576e-05 1.90005C-9.21011e-05 1.40299 0.402852 1.00005 0.899908 1.00005L7.4999 1.00004C7.99696 1.00004 8.3999 1.40298 8.3999 1.90004C8.3999 2.39709 7.99696 2.80004 7.4999 2.80004L1.79991 2.80005L1.79991 6.77505C1.79991 7.27211 1.39697 7.67505 0.899909 7.67505Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatEditorIcon);
export default __webpack_public_path__ + "static/media/format-editor-icon.5c9f40f748e2c10f6c4726684f7b466c.svg";
export { ForwardRef as ReactComponent };